import { Component } from '@angular/core';
import { DialogService, DialogComponent } from 'ng2-bootstrap-modal';

import { RESETVIEWLABELS } from '../_constants/constants';
import { CustomerService } from '../_services/customer.service';

export interface ResetPinDialogModel {
    subValue: string;
    opcoValue: string;
    customerService: CustomerService;
}

@Component({
    templateUrl: 'reset.pin.dialog.component.html'
})

export class ResetPinDialogComponent extends DialogComponent<ResetPinDialogModel, string> implements ResetPinDialogModel {
  
    customerService: CustomerService;
    subValue: string;
    opcoValue: string;
    resetviewlabels = RESETVIEWLABELS;

    constructor(private ds: DialogService) {
          super(ds);
    }

    agentResetPinRequest() {
       if(this.opcoValue=='vo'){
            this.customerService.voResetPinPasswordRequest(this.subValue, this.opcoValue, this.ds);
        }
        this.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/reset/reset.pin.dialog.component.ts